import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: ''
  },
  getters: {
    // 获取数据
    getData(state) {
      return state.token
    }

  },
  mutations: {
    // 存储数据
    setData(state, payload) {
      state.token = payload
    },
    // 删除数据
    removeData(state) {
      state.token = null
    }
  },
  actions: {
  },
  modules: {
  }
})
